import React from 'react';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';
import classNames from 'classnames';
import { get } from 'lodash';

// components
import Date from 'planting-plan-form/Date';
import FertilizerProductInputsContainerConnected from 'products/FertilizerProductInputsContainer';
import ManualFertilityPlanNitrogenInputs from 'planting-plan-form/ManualFertilityPlanNitrogenInputs';
import SubstanceType from 'products/SubstanceType';

const baseString = 'vra-manual-fertility-plan-fertilizer-inputs';
const classString = classNames({
  [`${baseString}`]: true
});
let ManualFertilityPlanFertilizerInputs = ({
  disabled,
  hasSubstanceType,
  isAppMode,
  isVisible,
  maxDate,
  minDate,
  onSelectDate,
  onChangeNitrapyrin,
  onSelectSubstanceType,
  plantingPlanParams,
  substanceTypeIsNitrogen,
  substanceTypes,
  validationResult
}) => {
  const { date, substanceTypeUuid } = plantingPlanParams;

  return isVisible ? (
    <section className={classString}>
      <section className='vra-planting-plan-form__fieldset'>
        <Date
          disabled={disabled}
          headerText={getMessage('title-text__application-date')}
          isAppMode={isAppMode}
          maxDate={maxDate}
          minDate={minDate}
          onSelectDate={onSelectDate}
          selected={date}
          validationResult={get(validationResult, 'date')}
        />
      </section>
      <section className='vra-planting-plan-form__fieldset'>
        <SubstanceType
          disabled={disabled}
          isFormFieldset={true}
          onSelectSubstanceType={onSelectSubstanceType}
          selected={substanceTypeUuid}
          substanceTypes={substanceTypes}
        />
      </section>
      {hasSubstanceType && (
        <FertilizerProductInputsContainerConnected
          disabled={disabled}
          substanceTypeUuid={substanceTypeUuid}
        />
      )}
      <section className='vra-planting-plan-form__fieldset'>
        <ManualFertilityPlanNitrogenInputs
          disabled={disabled}
          isVisible={substanceTypeIsNitrogen}
          onChangeNitrapyrin={onChangeNitrapyrin}
          plantingPlanParams={plantingPlanParams}
        />
      </section>
    </section>
  ) : null;
};
ManualFertilityPlanFertilizerInputs.propTypes = {
  disabled: propTypes.bool,
  hasSubstanceType: propTypes.bool.isRequired,
  isAppMode: propTypes.bool.isRequired,
  isVisible: propTypes.bool.isRequired,
  maxDate: propTypes.string.isRequired,
  minDate: propTypes.string.isRequired,
  onChangeNitrapyrin: propTypes.func.isRequired,
  onSelectDate: propTypes.func.isRequired,
  onSelectSubstanceType: propTypes.func.isRequired,
  plantingPlanParams: propTypes.object.isRequired,
  substanceTypeIsNitrogen: propTypes.bool.isRequired,
  substanceTypes: propTypes.object.isRequired,
  validationResult: propTypes.object
};
export default ManualFertilityPlanFertilizerInputs;
